import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

// `activePath` (optional): the page this item stands for, when `path` carries
// extra address settings (e.g. "/connect?tab=correspondence"). Defaults to `path`.
// `alsoActiveOn` (optional): older addresses that now live inside this page, so
// the item still lights up there (e.g. /messages inside the Family Connect Hub).
// An item also stays lit on its own sub-pages (/settings/... under Settings);
// Home, at "/", lights up only on itself.
function NavigationTab({ label, icon, path, activePath = path, alsoActiveOn = [], tag, disabled }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive =
    location.pathname === activePath ||
    (activePath !== "/" && location.pathname.startsWith(`${activePath}/`)) ||
    alsoActiveOn.includes(location.pathname);

  const handleClick = () => {
    if (!disabled) {
      navigate(path);
    }
  };

  // A real button, so the menu works from the keyboard and a screen reader
  // announces it; it looks exactly as the old clickable row did.
  return (
    <button
      type="button"
      aria-current={isActive ? "page" : undefined}
      aria-disabled={disabled || undefined}
      className={`flex flex-row w-full items-center px-[24px] py-[12px] justify-between text-left transition-all duration-200 ${
        isActive
          ? "bg-gradient-to-r from-[#0a1628] to-[#00194F] border-r-[3px] border-dupontGold"
          : "hover:bg-[#0a1628] border-r-[3px] border-transparent"
      } ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
      onClick={handleClick}
    >
      <div className="flex flex-row items-center gap-x-[12px]">
        {icon}
        <span className={`text-[16px] font-display tracking-wide ${isActive ? "text-dupontGold font-semibold" : "text-white/80 font-normal"}`}>
          {label}
        </span>
      </div>
      {tag}
    </button>
  );
}

export default NavigationTab;
